/** @flow */

export const USER_TYPES = {
  ADMIN: "ADMIN",

  /* Operating Company Types */
  /* U1 */ ABSENCE_ADVISOR: "ABSENCE_ADVISOR",
  /* U3 */ NURSE_ADVISOR: "NURSE_ADVISOR",
  /* U4 */ LEAD_NURSE_ADVISOR: "LEAD_NURSE_ADVISOR",
  /* U5 */ CONTACT_CENTRE_MANAGER: "CONTACT_CENTRE_MANAGER",
  /* U6 */ SERVICE_DELIVERY_ADVISOR: "SERVICE_DELIVERY_ADVISOR",
  /* U7 */ SUPPORT_CONTRACT_MANAGER: "SUPPORT_CONTRACT_MANAGER",
  /* U8 */ SERVICE_MANAGER: "SERVICE_MANAGER",
  /* U9 */ FULL_ACCESS: "FULL_ACCESS",

  /* Client Types */
  /* U10 */ EMPLOYEE: "EMPLOYEE",
  /* U11 */ MANAGER: "MANAGER",
  /* U12 */ ADVANCED_USER: "ADVANCED_USER",
  /* U13 */ CLIENT_FULL_ACCESS: "CLIENT_FULL_ACCESS",
  /* U14 */ CLIENT_ADMIN: "CLIENT_ADMIN",
  /* U15 */ CLIENT_DATA_TRANSFER: "CLIENT_DATA_TRANSFER",
  /* U16 */ CLIENT_TREND_VIEWER: "CLIENT_TREND_VIEWER",
  /* U17 */ CLIENT_SUPPLIER: "CLIENT_SUPPLIER",
  DEVELOPER: "DEVELOPER",
  THIRD_PARTY_APPLICATION: "THIRD_PARTY_APPLICATION",
  TEXT_TO_CLOSE_SERVICE: "TEXT_TO_CLOSE_SERVICE",
  FULL_HR_ACCESS: "FULL_HR_ACCESS",
};

export const USER_TYPES_LANDING_PAGES = {
  [USER_TYPES.ADMIN]: "HOME_PATH",
  // GoodShape User types
  [USER_TYPES.ABSENCE_ADVISOR]: "RECORDING_PATH",
  [USER_TYPES.NURSE_ADVISOR]: "RECORDING_PATH",
  [USER_TYPES.LEAD_NURSE_ADVISOR]: "RECORDING_PATH",
  [USER_TYPES.CONTACT_CENTRE_MANAGER]: "MANAGEMENT_CONTACT_CENTRE_DASHBOARD_PATH",
  // Client User Types
  [USER_TYPES.MANAGER]: "REPORTING_DASHBOARD_PATH",
  [USER_TYPES.ADVANCED_USER]: "REPORTING_DASHBOARD_PATH",
  [USER_TYPES.CLIENT_FULL_ACCESS]: "REPORTING_DASHBOARD_PATH",
  [USER_TYPES.CLIENT_DATA_TRANSFER]: "ADMINISTRATION_DATA_ADMIN_PATH",
};

export const CLIENT_SETTINGS_PERMISSIONS = {
  EAP_SIGNPOSTING: "eapSignposting",
  REFERRAL_TRACKING: "referralTracking",
  ABSENCE_MONITORING: "absenceMonitoring",
  DATA_FORECASTING_ACCESS: "dataForecastingAccess",
};
